// extracted by mini-css-extract-plugin
export default {"floor_and_point":"InfoGroup_floor_and_point__JJQdG","category_wrapper":"InfoGroup_category_wrapper__Naxdd","web_floor_and_point":"InfoGroup_web_floor_and_point__TADwO"};